// This is in a seperate file to deal with an issue trying to mock this
// inside of sessionDateFormatter which is mocking dayJs
import type dayjs from "dayjs";

export function doesSpanMultipleDays(start: dayjs.Dayjs, end: dayjs.Dayjs): boolean {
  return !start.isSame(end, "day");
}
